export const CounterSectionCss = {
  main: {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    paddingTop: "100px",
    paddingBottom: "100px"
  },
  value: {
    color: "#f4181c",
    fontSize: "50px",
    fontWeight: "600",
    lineHeight: 1,
    margin: "0 0 10px"
  },
  title: {
    color: "#ffffff",
    fontSize: "25px",
    margin: 0
  }
};
